import script from "./Carrers.vue?vue&type=script&setup=true&lang=js"
export * from "./Carrers.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__